<template>
	<div class="medical-records cart-section h-100">
	    <div class="row h-100">
	        <div class="col-12 mb-4 Order Confirmed h-100">
	            <div class="bg-white border-radius-5 p-5 Order h-100">
	                <div class="card border-0">
	                    <div class="card-body p-0">
	                        <div class="row justify-content-center order-confirmed pt-3">
	                            <div class="col-md-5 text-center">
	                                <i class="icon icon-check mb-4"></i>
	                                <h3>Thank You</h3>
	                                <p>Your Order has been Confirmed!</p>
	                                <router-link to="/nutriion-suppliments" class="btn btn-blue Proceed-checkout">Go to Shop</router-link>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
    export default {
        name: "order",
        data() {
            return {};
        },
        created() {
            this.pageName("Order Confirmed");
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/website/nutrition/pages/suppliment-order-confirm.vue